const Cookie = {
  install: function (Vue) {
    Vue.prototype.$cookie = this;
    Vue.$cookie = this;
  },

  set: function (key, value) {
    document.cookie = `${key}=${value}`;
  },

  get: function (key, parseType) {
    const splitCookie = document.cookie.split(";");
    if(splitCookie.length == 0) {
      return null;
    }

    for (let i = 0; i < splitCookie.length; i++) {
      const cookie = splitCookie[i].replace(" ", "").split("=");
      if (cookie[0] == key) {
        let result = null;

        switch (parseType) {
          case "bool":
            result = ( cookie[1] == "true" );
          break;
          default:
            result = cookie[1];
        }

        return result;
      }
    }

    return null;
  },

  remove: function(key) {
    document.cookie = `${key}=;max-age=0`;
  }
};

export default Cookie;